<h2 mat-dialog-title style="text-align: center">{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <!--<h3 *ngIf="data.timeseries?.length == 0">{{data.content}} -> {{data.id}}</h3>-->
  <div
    *ngIf="data.wait"
    fxLayout="row"
    fxLayoutAlign="space-around center"
    style="text-align: center"
  >
    <mat-spinner [diameter]="75"></mat-spinner>
  </div>
  <div *ngIf="data.option == -2" id="">
    <div
      style="
        width: 100%;
        padding: 10px;
        border: 1px dashed #efefef;
        margin-bottom: 10px;
      "
    >
      <table
        mat-table
        [dataSource]="dataSourceNotificationUserListAlarms"
        class="mat-elevation-z8"
      >
        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="uuid">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            UUID
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.uuid }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="usuario">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Usuario
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.usuario }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="text-align: center">
            Email
          </th>
          <td mat-cell *matCellDef="let element" style="text-align: center">
            {{ element.mail }}
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsNotificationUserListAlarms"
        ></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            columns: displayedColumnsNotificationUserListAlarms
          "
        ></tr>
      </table>
      <mat-paginator
        #paginator1="matPaginator"
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </div>
  <div *ngIf="data.option == -1 && data.id == -1" id="">
    <div
      style="
        width: 100%;
        padding: 10px;
        border: 1px dashed #efefef;
        margin-bottom: 10px;
      "
    >
      <!-- TODO: Revisar los parámetros que faltan -->
      <!-- <form (ngSubmit)="onSubmit()" [formGroup]="AlarmaForm">
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>{{'ALARMA_FORM.NAME' | translate}}</mat-label>
          <input matInput formControlName="AlarmaNameControl">
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>{{'ALARMA_FORM.DESCRIPTION' | translate}}</mat-label>
          <textarea matInput formControlName="AlarmaDescriptionControl"></textarea>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 100%;">
          <mat-label>{{'ALARMA_FORM.SELECT_TYPE' | translate}}</mat-label>
          <mat-select formControlName="AlarmaTypeControl" (selectionChange)="selectionChangeAlarmaType()" [(value)]="SelectedAlarmaType">
            <mat-option *ngFor="let alarmaType of data.types " [value]="alarmaType">
                {{alarmaType.nombre}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="SelectedAlarmaType !== undefined; else elseTemplate">
          <mat-form-field class="alarma-field" appearance="fill" style="width: 100%;">
              <mat-label>{{'ALARMA_FORM.FUNCTION' | translate}}</mat-label>
              <input matInput readonly [value]="SelectedAlarmaType.formula">
          </mat-form-field>
          <div formArrayName="AlarmaFieldControls" *ngIf="tipoAlarmaFields">
              <div *ngFor="let tipoAlarmaField of TipoAlarmaFieldControls|async; let i = index">
                  <ng-container *ngIf="tipoAlarmaFields[i].tipo=='variable'; else elseTemplate">
                      <mat-form-field class="alarma-field" appearance="fill" style="width: 100%;">
                          <mat-label>{{tipoAlarmaFields[i].clave}}</mat-label>
                          <input matInput readonly [formControlName]="i">
                          <button mat-icon-button type="button" matSuffix (click)="showModalDatos(i)" [attr.aria-label]="''" [attr.aria-pressed]="">
                            <mat-icon>search</mat-icon>
                          </button>
                      </mat-form-field>
                  </ng-container>
                  <ng-template #elseTemplate>
                      <mat-form-field class="alarma-field" appearance="outline" style="width: 100%;">
                          <mat-label>{{tipoAlarmaFields[i].clave}}</mat-label>
                          <input matInput type=number [formControlName]="i">
                      </mat-form-field>
                  </ng-template>
              </div>
          </div>
        </ng-container>
        <ng-template #elseTemplate></ng-template>
        <mat-form-field class="alarma-field" appearance="outline" style="width: 100%;">
            <mat-label>{{'ALARMA_FORM.TIMEOUT' | translate}}</mat-label>
            <input type="number" matInput formControlName="AlarmaTimeoutControl">
        </mat-form-field>
        <mat-form-field class="alarma-field" appearance="fill" style="width: 100%;">
            <mat-label>{{'TITLES.USERS' | translate}}</mat-label>
            <mat-select multiple formControlName="AlarmaUsersControl">
              <mat-option *ngFor="let user of data.users" [value]="user">{{user.user}}</mat-option>
            </mat-select>
        </mat-form-field>
      </form> -->
    </div>
  </div>
  <div *ngIf="data.option == 0 && data.id != -1" id="">
    <div
      style="
        width: 100%;
        padding: 10px;
        border: 1px dashed #efefef;
        margin-bottom: 10px;
      "
    >
      <form></form>
    </div>
  </div>
  <div *ngIf="data.option == 1 && data.id != -1" id="">
    <div
      style="
        width: 100%;
        padding: 10px;
        border: 1px dashed #efefef;
        margin-bottom: 10px;
      "
    >
      ¿Desea usted <b>eliminar</b> la alarma con UUID <b>{{ data.id }}</b
      >?<br />
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
  <div *ngIf="data.option == 2 && data.id != -1" id="">
    <div
      style="
        width: 100%;
        padding: 10px;
        border: 1px dashed #efefef;
        margin-bottom: 10px;
      "
    >
      ¿Desea usted <b>rearmar</b> la alarma con UUID <b>{{ data.id }}</b
      >?<br />
      <b>NOTA: Esta operación es irreversible</b>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    *ngIf="data.option == -1 && data.id == -1"
    mat-raised-button
    mat-dialog-close
    color="primary"
    (click)="doAddAlarm()"
  >
    Añadir
  </button>
  <button
    *ngIf="data.option == 0"
    mat-raised-button
    mat-dialog-close
    color="primary"
    (click)="doEditAlarm(data.type, data.id)"
  >
    Editar
  </button>
  <button
    *ngIf="data.option == 1"
    mat-raised-button
    mat-dialog-close
    color="primary"
    (click)="doRemoveAlarm(data.type, data.id)"
  >
    Eliminar
  </button>
  <button mat-raised-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
